import { Box, Stack, Typography } from "@mui/material";

// import CreateDevicesFromTemplateDialogContainer from "./CreateDevicesFromTemplateDialogContainer";
import { useAuthenticatedUser } from "../../../common/hooks/useAuthenticatedUser";
import { RoleEnum } from "../../../common/models/enums";
import AddStreamDialogContainer from "./AddStreamDialogContainer";
import CreateDeviceDialogContainer from "./CreateDeviceDialogContainer";
import CreateDevicesFromTemplateDialogContainer from "./CreateDevicesFromTemplateDialogContainer";

export const DEVICE_TEMPLATE_ADMIN_ACCESS = [
  RoleEnum.ROOT,
  RoleEnum.CC_OPS_ADMIN,
  RoleEnum.CC_OPS,
];

const DevicesPageHeader = (): JSX.Element => {
  const { role } = useAuthenticatedUser();

  return (
    <Box padding="0" marginBottom="1em">
      <Stack spacing={4} direction="row" alignItems="center">
        <Typography variant="h3" padding={0} sx={{ flexGrow: 1 }}>
          Devices
        </Typography>
        {DEVICE_TEMPLATE_ADMIN_ACCESS.includes(role) && (
          <CreateDevicesFromTemplateDialogContainer />
        )}
        <CreateDeviceDialogContainer />
        {[RoleEnum.ROOT, RoleEnum.CUSTOMER_ADMIN].includes(role) && (
          <AddStreamDialogContainer />
        )}
      </Stack>
    </Box>
  );
};

export default DevicesPageHeader;
